<div class="card incidencia-ia-ticket-modal">
  <div class="card-header card-header-primary">
    <div class="row">
      <div class="col-sm-12 col-md-11">
        <h4 class="card-title"><b>{{ titulo }}</b></h4>
        <p class="card-category" *ngIf="muestraApertura">
          Registra los datos base del evento IA. La fecha de apertura y el usuario se asignan automáticamente.
        </p>
        <p class="card-category" *ngIf="muestraSeguimiento">
          Complementa la información de atención y conserva las observaciones como conversación.
        </p>
      </div>
      <div class="col-sm-12 col-md-1 text-right">
        <button mat-icon-button type="button" aria-label="Cerrar" (click)="cancelar()" tabindex="0">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="card-body" [class.incidencia-ia-ticket-modal__body--seguimiento]="muestraSeguimiento">
    <div class="wraper">
      <div class="container">
        <div class="alert alert-danger incidencia-ia-ticket-modal__alert" *ngIf="error">
          <i class="material-icons">error_outline</i>
          <span>{{ error }}</span>
        </div>

        <div class="alert alert-warning incidencia-ia-ticket-modal__alert" *ngIf="advertencia">
          <i class="material-icons">warning_amber</i>
          <span>{{ advertencia }}</span>
        </div>

        <div class="text-center text-muted my-4" *ngIf="cargando">
          <i class="material-icons">hourglass_top</i>
          <strong>Cargando...</strong>
        </div>

        <form #form="ngForm" novalidate (ngSubmit)="guardar()" *ngIf="!cargando">
          <div class="row" *ngIf="muestraApertura">
            <div class="col-sm-6 border-right">
              <div class="col-sm-12">
                <mat-form-field>
                  <mat-select [(ngModel)]="incidencia.idInventarioIa" name="idInventarioIa" required>
                    <mat-option [value]="null">Selecciona una herramienta</mat-option>
                    <mat-option *ngFor="let inventario of inventarios" [value]="inventario.idInventarioIa">
                      {{ inventario.consecutivo }} - {{ inventario.nombreIa }}
                    </mat-option>
                  </mat-select>
                  <mat-label><b>Herramienta o agente IA</b></mat-label>
                </mat-form-field>
              </div>

              <div class="col-sm-12">
                <mat-form-field>
                  <input aria-label="Proyecto, sistema o actividad" matInput placeholder="Proyecto, sistema o actividad" maxlength="90"
                    [(ngModel)]="incidencia.proyectoSistemaActividad" name="proyectoSistemaActividad" required />
                </mat-form-field>
              </div>

              <div class="col-sm-12">
                <mat-form-field>
                  <mat-select [(ngModel)]="incidencia.tipoEvento" name="tipoEvento" required>
                    <mat-option *ngFor="let option of tipoEventoOptions" [value]="option.value">
                      {{ option.label }}
                    </mat-option>
                  </mat-select>
                  <mat-label><b>Tipo de evento</b></mat-label>
                </mat-form-field>
              </div>

              <div class="col-sm-12">
                <mat-form-field>
                  <textarea aria-label="Descripción del evento" matInput placeholder="Descripción del evento" rows="5" maxlength="500"
                    [(ngModel)]="incidencia.descripcionEvento" name="descripcionEvento" required></textarea>
                </mat-form-field>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="row">
                <div class="col-sm-6">
                  <div class="incidencia-ia-field-with-hint">
                    <mat-form-field>
                      <mat-select [(ngModel)]="incidencia.gravedad" name="gravedad" required>
                        <mat-option *ngFor="let option of gravedadOptions" [value]="option.value"
                          [matTooltip]="option.description || ''">
                          {{ option.label }}
                        </mat-option>
                      </mat-select>
                      <mat-label><b>Gravedad</b></mat-label>
                    </mat-form-field>
                    <p class="incidencia-ia-ticket-modal__hint" *ngIf="getDescripcionGravedad()">
                      {{ getDescripcionGravedad() }}
                    </p>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="incidencia-ia-field-with-hint">
                    <mat-form-field>
                      <mat-select [(ngModel)]="incidencia.prioridad" name="prioridad" required>
                        <mat-option *ngFor="let option of prioridadOptions" [value]="option.value"
                          [matTooltip]="option.description || ''">
                          {{ option.label }}
                        </mat-option>
                      </mat-select>
                      <mat-label><b>Prioridad</b></mat-label>
                    </mat-form-field>
                    <p class="incidencia-ia-ticket-modal__hint" *ngIf="getDescripcionPrioridad()">
                      {{ getDescripcionPrioridad() }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-sm-12">
                <mat-form-field>
                  <textarea aria-label="Riesgo identificado" matInput placeholder="Riesgo identificado" rows="5" maxlength="500"
                    [(ngModel)]="incidencia.riesgoIdentificado" name="riesgoIdentificado"></textarea>
                </mat-form-field>
              </div>

              <div class="col-sm-12">
                <mat-form-field>
                  <textarea aria-label="Impacto" matInput placeholder="Impacto" rows="5" maxlength="500" [(ngModel)]="incidencia.impacto"
                    name="impacto"></textarea>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="row incidencia-ia-process-layout" *ngIf="muestraSeguimiento">
            <div class="col-sm-6 border-right incidencia-ia-process-layout__main">
              <div class="col-sm-12" *ngIf="incidencia.nombreResponsableSeguimiento">
                <div class="incidencia-ia-ticket-modal__assigned" matTooltip="Doble clic para cambiar responsable"
                  (dblclick)="cambiarResponsableAsignado()">
                  <span>Responsable asignado</span>
                  <strong>{{ incidencia.nombreResponsableSeguimiento }}</strong>
                  <small>{{ incidencia.responsableSeguimientoPerfil || incidencia.responsableSeguimientoCargo }}</small>
                </div>
              </div>

              <div class="col-sm-12">
                <mat-form-field>
                  <mat-label><b>Fecha planeada de resolución</b></mat-label>
                  <input aria-label="Fecha planeada de resolución" matInput [matDatepicker]="pickerPlaneada" [min]="minFechaPlaneada"
                    placeholder="Fecha planeada de resolución" [(ngModel)]="incidencia.fechaPlaneadaResolucion"
                    name="fechaPlaneadaResolucion" [disabled]="soloLecturaCampos" required />
                  <mat-datepicker-toggle matSuffix [for]="pickerPlaneada"
                    [disabled]="soloLecturaCampos"></mat-datepicker-toggle>
                  <mat-datepicker #pickerPlaneada></mat-datepicker>
                </mat-form-field>
              </div>

              <div class="col-sm-12">
                <mat-form-field>
                  <textarea aria-label="Acción correctiva" matInput placeholder="Acción correctiva" rows="5" maxlength="500"
                    [(ngModel)]="incidencia.accionCorrectiva" name="accionCorrectiva" [disabled]="soloLecturaCampos"
                    required></textarea>
                </mat-form-field>
              </div>

              <div class="col-sm-12">
                <mat-form-field>
                  <textarea aria-label="Validación humana realizada" matInput placeholder="Validación humana realizada" rows="5" maxlength="500"
                    [(ngModel)]="incidencia.validacionHumanaRealizada" name="validacionHumanaRealizada"
                    [disabled]="soloLecturaCampos" required></textarea>
                </mat-form-field>
              </div>
            </div>

            <div class="col-sm-6 incidencia-ia-process-layout__side">
              <div class="incidencia-ia-panel" [class.is-open]="panelDerecho === 'observaciones'">
                <button type="button" class="incidencia-ia-panel__header" (click)="abrirPanelDerecho('observaciones')">
                  <span>Observaciones</span>
                  <i class="material-icons">expand_more</i>
                </button>
                <div class="incidencia-ia-panel__body" *ngIf="panelDerecho === 'observaciones'">
                  <div class="incidencia-ia-comments" *ngIf="comentarios.length; else sinComentarios">
                    <div class="incidencia-ia-comment"
                      *ngFor="let comentario of comentarios; trackBy: trackByComentario">
                      <div class="incidencia-ia-comment__meta">
                        <strong>{{ comentario.nombreUsuario || "Usuario" }}</strong>
                        <span>{{ comentario.fechaComentario ? (comentario.fechaComentario | date: "dd/MM/yyyy HH:mm") :
                          "-" }}</span>
                      </div>
                      <p>{{ comentario.comentario }}</p>
                    </div>
                  </div>
                  <ng-template #sinComentarios>
                    <div class="incidencia-ia-comments__empty">Sin comentarios registrados.</div>
                  </ng-template>

                  <mat-form-field>
                    <textarea aria-label="Agregar comentario" matInput placeholder="Agregar comentario" rows="4" maxlength="500"
                      [(ngModel)]="nuevoComentario" name="nuevoComentario" [disabled]="soloConsulta"></textarea>
                  </mat-form-field>
                </div>
              </div>

              <div class="incidencia-ia-panel" [class.is-open]="panelDerecho === 'porques'">
                <button type="button" class="incidencia-ia-panel__header" (click)="abrirPanelDerecho('porques')">
                  <span>Causa / Origen</span>
                  <i class="material-icons">expand_more</i>
                </button>
                <div class="incidencia-ia-panel__body" *ngIf="panelDerecho === 'porques'">
                  <div class="incidencia-ia-porques">
                    <div class="incidencia-ia-porques__header">
                      <div>
                        <strong>Causa / Origen</strong>
                        <p>Los primeros cinco son obligatorios; puedes agregar más si aplica.</p>
                      </div>
                      <button mat-icon-button type="button" class="incidencia-ia-porques__info"
                        matTooltip="Más información" aria-label="Más información sobre Causa / Origen"
                        (click)="abrirInformacionCausaOrigen()">
                        <mat-icon>info</mat-icon>
                      </button>
                      <button mat-button type="button" class="btn btn-info btn-sm" (click)="agregarPorque()"
                        [disabled]="soloLecturaCampos">
                        Agregar porqué <i class="material-icons">add</i>
                      </button>
                    </div>

                    <div class="incidencia-ia-porques__scroll">
                      <div class="incidencia-ia-porque"
                        *ngFor="let porque of porques; let i = index; trackBy: trackByPorque">
                        <div class="incidencia-ia-porque__question">
                          <span>{{ i + 1 }}</span>
                          <strong>{{ preguntaPorque(i) }}</strong>
                          <button mat-icon-button type="button" aria-label="Eliminar porqué" *ngIf="i >= 5"
                            (click)="eliminarPorque(i)" [disabled]="soloLecturaCampos">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>
                        <mat-form-field>
                          <input [attr.aria-label]="'Respuesta ' + (i + 1)" matInput [placeholder]="'Respuesta ' + (i + 1)" maxlength="100"
                            [(ngModel)]="porques[i]" [name]="'porque' + i" [disabled]="soloLecturaCampos" />
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>

        <div class="row">
          <div class="col-sm-6 border-right ml-auto">
            <div mat-dialog-actions class="justify-content-end">
              <button mat-button class="btn btn-danger" type="button" (click)="cancelar()" tabindex="0">
                <i class="fa fa-times-circle-o"></i> Cancelar
              </button>
              <button mat-button type="button" (click)="guardar()" class="btn btn-success"
                [disabled]="guardando || cargando || soloConsulta" tabindex="0">
                {{ textoBotonGuardar }} <i class="material-icons">save</i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
